module.exports = __webpack_public_path__ + "img/30-viking.49476a15.svg";